exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".region-name[data-v-7149b1e0] {\n  width: 70%;\n}\n.region-action[data-v-7149b1e0] {\n  width: 30%;\n}\n.handle[data-v-7149b1e0] {\n  cursor: grab;\n  padding: 10px;\n  text-align: center;\n}\n.handle[data-v-7149b1e0]:active {\n  cursor: grabbing;\n}\n", ""]);

// exports
